import type { ReactNode } from 'react'
import React from 'react'
import { toast } from 'react-toastify'
import { Alert } from '../../common/Alert'

export type NotifyOptions = {
  toastId?: string
  type?: 'error' | 'info' | 'success'
  autoClose?: number | false
}

const notify = (message: ReactNode, options?: NotifyOptions) => {
  return toast(
    ({ closeToast }) => (
      <Alert message={message} type={options?.type || 'error'} onClose={closeToast} />
    ),
    options,
  ) as unknown as string
}

const update: typeof toast.update = (toastId, options) => {
  toast.update(toastId, options)
}

const dismiss = (toastId: string) => {
  toast.dismiss(toastId)
}

const dismissAll = () => {
  toast.dismiss()
}

export { dismiss, dismissAll, notify, toast, update }
